import './HomeStyle.css';
import MyHeader from './MyHeader';
import {ConfigProvider} from 'antd';
import bg1 from '../resource/bg_1.jpg';
import blockBg1 from '../resource/block-1-bg.jpg';
import b4b1 from '../resource/accompany_bg.jpg';
import b4b2 from '../resource/empower_bg.jpg';
import b4b3 from '../resource/create_bg.jpg';
import b5i1 from '../resource/intelligent_manufacturing.png';
import b5i2 from '../resource/new_consumption.jpg';
import b5i3 from '../resource/innovative_technology.webp';
import b6i1 from '../resource/united_imaging_icon.png';
import b6i2 from '../resource/xh_icon.png';
import b6i3 from '../resource/meiyu_icon.webp';
import b6i4 from '../resource/eaglechip.png';
import b6i5 from '../resource/laowang_icon.png';
import b6b1 from '../resource/united_imaging_bg.png';
import b6b2 from '../resource/xh_bg.jpg';
import b6b3 from '../resource/meiyu_bg.png';
import b6b4 from '../resource/eaglechip_bh.png';
import b6b5 from '../resource/laowang_bg.webp';
import b7b1 from '../resource/news.webp';
import news1 from '../resource/eagle-chip-1.png';
import news2 from '../resource/want-hotpot-1.png';
import {useEffect} from 'react';
import MyFooter from './MyFooter';
import {motion} from 'motion/react';
import {useLocation} from 'react-router-dom';

export default function Home() {
  
  const {hash} = useLocation();
  
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({});
          const height = window.scrollY;
          window.scroll(0, height - 100);
        }, 100);
      }
    }
  }, [hash]);
  
  useEffect(() => {
    const imagesToPreload = [bg1, blockBg1, b4b1, b4b2, b4b3, b5i1, b5i2, b5i3, b6i1, b6i2, b6i3, b6i4, b6i5, b6b1, b6b2, b6b3, b6b4, b6b5, b7b1, news1, news2];
    imagesToPreload.forEach((img) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = img;
      link.as = 'image';
      document.head.appendChild(link);
    });
  }, []);
  
  return (
    <div className="home">
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              horizontalItemSelectedBg: '#ffffff',
              horizontalItemSelectedColor: '#203864',
              itemColor: '#203864',
              itemPaddingInline: 24,
              activeBarHeight: 0,
            },
            Collapse: {
              contentPadding: 0
            }
          },
        }}
      >
        <MyHeader></MyHeader>
        <section className="block-1">
          <img className="block-bg" src={blockBg1} alt="background"/>
          <div className="block-bg-overlay"></div>
          <div className="block-1-content">
            <motion.div
              className="block-1-line"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            >
              <span style={{margin: 0, zIndex: 2}}>聚焦创新科技、智能制造、新型消费领域</span>
            </motion.div>
            <motion.div
              className="block-1-line"
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0.1, ease: [0.25, 0.1, 0.25, 1]}}
            >
              <h1 style={{margin: 0, zIndex: 2}}>赋能企业出海与产业整合</h1>
            </motion.div>
          </div>
        </section>
        <section className="block-2" id="about">
          <motion.div
            className="p-content"
            initial={{opacity: 0, x: -20}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.2}}
          >
            <div>
              <h1>关于我们</h1>
              <p className="home-text">
                上海晨联投资管理有限公司（以下简称“晨联投资”）成立于2016年，是经中国证券投资基金业协会登记的私募基金管理机构
                <span style={{whiteSpace: 'nowrap'}}>（登记编号P1062669）</span>。
              </p>
              <p className="home-text">
                晨联投资管理的基金专注于投资创新科技、智能制造、新型消费领域的价值创造型企业，并通过企业出海、产业整合等多方位赋能，推动企业的协同创新和可持续发展，催生新质生产力，加速产业转型升级。
              </p>
            </div>
          </motion.div>
          <motion.div
            className="block-1-img-container"
            initial={{opacity: 0, x: 20}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.2}}
          >
            <img className="block-1-img" src={bg1} alt="About"/>
          </motion.div>
        </section>
        <section className="block-4" id="idea">
          <div className="block-4-layout">
            <motion.div
              className="block-4-content"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
              viewport={{once: true, amount: 0.4}}
            >
              <h1>投资理念</h1>
              <p style={{marginTop: 0}} className="home-text">
                晨联投资秉持“创新推动可持续发展”的价值投资理念，构建「投资管理+出海赋能+产业并购」的三维矩阵，为企业提供多层次资金支持、国内外资本配置优化、精准化出海对接、多元化产业整合等全方位服务，借助产业生态圈的布局，双向赋能已投和拟投企业，为协同创新和长足发展注入动能，推动产业的转型升级。
              </p>
            </motion.div>
            <motion.div
              className="bar-container"
              initial="hidden"
              whileInView="visible"
              viewport={{once: true, amount: 0.5}}
            >
              <motion.div
                className="bar-group bar-height-1"
                variants={{
                  hidden: {
                    opacity: 0
                  },
                  visible: {
                    opacity: 1
                  }
                }}
                transition={{duration: 0.8, delay: 0.4, ease: 'easeInOut'}}
              >
                <p className="bar-text">陪伴</p>
                <div className="bar">
                  <img className="bar-img" src={b4b1} alt="Accompany"/>
                </div>
              </motion.div>
              <motion.div
                className="bar-group bar-height-2"
                variants={{
                  hidden: {
                    opacity: 0
                  },
                  visible: {
                    opacity: 1
                  }
                }}
                transition={{duration: 0.8, delay: 0.6, ease: 'easeInOut'}}
              >
                <p className="bar-text">赋能</p>
                <div className="bar">
                  <img className="bar-img" src={b4b2} alt="Empower"/>
                </div>
              </motion.div>
              <motion.div
                className="bar-group bar-height-3"
                variants={{
                  hidden: {
                    opacity: 0
                  },
                  visible: {
                    opacity: 1
                  }
                }}
                transition={{duration: 0.8, delay: 0.8, ease: 'easeInOut'}}
              >
                <p className="bar-text">创新</p>
                <div className="bar">
                  <img className="bar-img" src={b4b3} alt="Create"/>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>
        <section className="block-5" id="area">
          <motion.div
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.4}}
          >
            <h1>投资领域</h1>
            <p className="block-5-p home-text">
              晨联投资关注创新科技、智能制造、新型消费等领域企业。
            </p>
          </motion.div>
          <div className="block-5-img-list">
            <motion.div
              className="block-5-img-group"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0.3, ease: [0.25, 0.1, 0.25, 1]}}
              viewport={{once: true, amount: 0.4}}
            >
              <img src={b5i3} alt="innovative technology" className="block-5-img"/>
              
              <div className="img-caption">
                <span className="img-caption-title">创新科技</span><br/>
                <span className="img-caption-sub">基于自主可控的国产替代</span>
              </div>
            </motion.div>
            <motion.div
              className="block-5-img-group"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
              viewport={{once: true, amount: 0.4}}
            >
              <img src={b5i1} alt="intelligent manufacturing" className="block-5-img"/>
              <div className="img-caption">
                <span className="img-caption-title">智能制造</span><br/>
                <span className="img-caption-sub">基于链接全球的智造出海</span>
              </div>
            </motion.div>
            <motion.div
              className="block-5-img-group"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0.15, ease: [0.25, 0.1, 0.25, 1]}}
              viewport={{once: true, amount: 0.4}}
            >
              <img src={b5i2} alt="new consumption" className="block-5-img"/>
              
              <div className="img-caption">
                <span className="img-caption-title">新型消费</span><br/>
                <span className="img-caption-sub">基于消费迭代的价值重构</span>
              </div>
            </motion.div>
          </div>
        </section>
        <section className="block-6" id="case">
          <motion.div
            style={{width: '100%', textAlign: 'center'}}
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.4}}
          >
            <h1 style={{color: '#ffffff', marginTop: 0, marginBottom: 64}} key="b6h1">投资案例</h1>
          </motion.div>
          <div
            className="block-6-img-list"
          >
            <div className="block-6-img-category-group">
              <motion.div
                initial={{opacity: 0, y: 20}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1]}}
                viewport={{once: true, amount: 0.4}}
              >
                <div className="block-6-img-group">
                  <img src={b6i1} alt="United Imaging" className="block-6-img-list-icon"></img>
                  <img src={b6b1} alt="United Imaging Bg" className="block-6-img-list-bg"></img>
                  <div className="block-6-overlay-text">
                    <p className="home-text">
                      联影医疗（688271.SH）是中国高端医疗影像设备行业龙头，提供全线自主研发的高性能医学影像、放疗产品、生命科学仪器及医疗数字化解决方案，包括磁共振成像、X射线计算机断层扫描、X射线成像、分子影像、医用直线加速器等。
                    </p>
                  </div>
                </div>
              </motion.div>
              <motion.div
                initial={{opacity: 0, y: 20}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8, delay: 0.6, ease: [0.25, 0.1, 0.25, 1]}}
                viewport={{once: true, amount: 0.4}}
              >
                <div className="block-6-img-group">
                  <img src={b6i4} alt="Eagle Chip" className="block-6-img-list-icon"></img>
                  <img src={b6b4} alt="Eagle Chip Bg" className="block-6-img-list-bg"></img>
                  <div className="block-6-overlay-text">
                    <p className="home-text">
                      异格技术专注于国产高端FPGA芯片和专用EDA工具链的研发与设计，致力于突破高端FPGA芯片这一卡脖子环节，以创新技术与开放生态为客户创造更大价值。研发团队均来自世界顶尖学府，具备超过二十年的FPGA架构设计与EDA工具设计经验。
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
            <div className="block-6-img-category-group">
              <motion.div
                initial={{opacity: 0, y: 20}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
                viewport={{once: true, amount: 0.4}}
              >
                <div className="block-6-img-group">
                  <img src={b6i2} alt="XH Smart" className="block-6-img-list-icon"></img>
                  <img src={b6b2} alt="XH Smart Bg" className="block-6-img-list-bg"></img>
                  <div className="block-6-overlay-text">
                    <p className="home-text">
                      星汉智能专注于为全球新兴市场客户提供支付、通讯、金融、物联等产品及整体解决方案，已经在珠海、南非、印度、孟加拉、重庆布局生产基地，并获得了全球多家主流电信运营商、金融机构和政府的认证资质，业务覆盖超过150个国家。
                    </p>
                  </div>
                </div>
              </motion.div>
              {/*<motion.div*/}
              {/*  initial={{opacity: 0, y: 20}}*/}
              {/*  whileInView={{opacity: 1, y: 0}}*/}
              {/*  transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}*/}
              {/*  viewport={{once: true, amount: 0.4}}*/}
              {/*  className="block-6-img-group-empty"*/}
              {/*></motion.div>*/}
            </div>
            <div className="block-6-img-category-group">
              <motion.div
                initial={{opacity: 0, y: 20}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8, delay: 0.5, ease: [0.25, 0.1, 0.25, 1]}}
                viewport={{once: true, amount: 0.4}}
              >
                <div className="block-6-img-group">
                  <img src={b6i3} alt="Meiyu" className="block-6-img-list-icon"
                       style={{width: '80%', minHeight: 150}}></img>
                  <img src={b6b3} alt="Meiyu Bg" className="block-6-img-list-bg"></img>
                  <div className="block-6-overlay-text">
                    <p className="home-text">
                      美育股份（NEEQ：833099）是一家文化教育集团控股有限公司，业务范围涵盖教育培训、文化传媒、科技应用，可为企业、学校、个人提供定制化的教育、旅游、文化产品。公司于2015年7月成功在新三板挂牌，并连续三年入选创新层，也多次入选上海市“专精特新”企业名单。
                    </p>
                  </div>
                </div>
              </motion.div>
              {/*<motion.div*/}
              {/*  initial={{opacity: 0, y: 20}}*/}
              {/*  whileInView={{opacity: 1, y: 0}}*/}
              {/*  transition={{duration: 0.8, delay: 0.3, ease: [0.25, 0.1, 0.25, 1]}}*/}
              {/*  viewport={{once: true, amount: 0.4}}*/}
              {/*>*/}
              {/*  <div className="block-6-img-group">*/}
              {/*    <img src={b6i5} alt="WANT HOTPOT" className="block-6-img-list-icon"></img>*/}
              {/*    <img src={b6b5} alt="WANT HOTPOT Bg" className="block-6-img-list-bg"></img>*/}
              {/*    <div className="block-6-overlay-text">*/}
              {/*      <p className="home-text">*/}
              {/*        捞王是全国十大火锅品牌之一，主打粤式猪肚鸡火锅，是该品类第一品牌。捞王以「用爱传递好味道」作为品牌理念，旨在让顾客有极致的火锅体验。自2010年开业至今，全国已有百余家门店，遍布中国12个省份和30座城市。*/}
              {/*      </p>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</motion.div>*/}
            </div>
          </div>
        </section>
        <section className="section-news" id="news">
          <motion.div
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.2}}
          >
            <h1 style={{textAlign: 'center'}}>企业新闻</h1>
          </motion.div>
          <div className="news-card-grid">
            {/*<motion.a*/}
            {/*  className="news-card"*/}
            {/*  href="/news/4"*/}
            {/*  rel="noopener noreferrer"*/}
            {/*  initial={{opacity: 0, y: 20}}*/}
            {/*  whileInView={{opacity: 1, y: 0}}*/}
            {/*  transition={{duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1]}}*/}
            {/*  viewport={{once: true, amount: 0.2}}*/}
            {/*>*/}
            {/*  <img src={news4} alt="Eagle Chip"/>*/}
            {/*  <div className="news-info">*/}
            {/*    <span className="news-title">异格技术自研高端FPGA芯片P2成功点亮！</span>*/}
            {/*    <span className="news-date">2026年4月9日</span>*/}
            {/*  </div>*/}
            {/*</motion.a>*/}
            {/*<motion.a*/}
            {/*  className="news-card"*/}
            {/*  href="/news/3"*/}
            {/*  rel="noopener noreferrer"*/}
            {/*  initial={{opacity: 0, y: 20}}*/}
            {/*  whileInView={{opacity: 1, y: 0}}*/}
            {/*  transition={{duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1]}}*/}
            {/*  viewport={{once: true, amount: 0.2}}*/}
            {/*>*/}
            {/*  <img src={news3} alt="Eagle Chip"/>*/}
            {/*  <div className="news-info">*/}
            {/*    <span className="news-title">异格技术完成数亿元A轮融资</span>*/}
            {/*    <span className="news-date">2026年2月</span>*/}
            {/*  </div>*/}
            {/*</motion.a>*/}
            <motion.a
              className="news-card"
              href="/news/1"
              rel="noopener noreferrer"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1]}}
              viewport={{once: true, amount: 0.2}}
            >
              <img src={news1} alt="Eagle Chip"/>
              <div className="news-info">
                <span className="news-title">异格技术首款量产芯片P1成功点亮！</span>
                <span className="news-date">2025年9月25日</span>
              </div>
            </motion.a>
            {/*<motion.a*/}
            {/*  className="news-card"*/}
            {/*  href="/news/2"*/}
            {/*  rel="noopener noreferrer"*/}
            {/*  initial={{opacity: 0, y: 20}}*/}
            {/*  whileInView={{opacity: 1, y: 0}}*/}
            {/*  transition={{duration: 0.8, delay: 0.4, ease: [0.25, 0.1, 0.25, 1]}}*/}
            {/*  viewport={{once: true, amount: 0.2}}*/}
            {/*>*/}
            {/*  <img src={news2} alt="Want Hotpot"/>*/}
            {/*  <div className="news-info">*/}
            {/*    <span className="news-title">捞王荣获全国首家低嘌呤认证火锅品牌</span>*/}
            {/*    <span className="news-date">2025年9月24日</span>*/}
            {/*  </div>*/}
            {/*</motion.a>*/}
          </div>
        </section>
        <section className="block-news" id="contact">
          <motion.div
            className="block-news-img-container"
            initial={{opacity: 0, x: -40}}
            whileInView={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.4}}
          >
            <img
              key="homw-news-2"
              className="block-news-img"
              src={b7b1}
              alt="News"
            />
          </motion.div>
          <motion.div
            className="p-content news-p-container"
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.8, delay: 0, ease: [0.25, 0.1, 0.25, 1]}}
            viewport={{once: true, amount: 0.4}}
          >
            <div key="homw-news-4" className="home-news-p">
              <h1>联系我们</h1>
              <br/>
              <p style={{marginBottom: 0}}>项目投递</p>
              <p>bp@morningalliance.cn</p>
              <p style={{marginBottom: 0}}>合作咨询</p>
              <p>info@morningalliance.cn</p>
              <p style={{marginBottom: 0}}>简历投递</p>
              <p>hr@morningalliance.cn</p>
            </div>
          </motion.div>
        </section>
        <MyFooter></MyFooter>
      </ConfigProvider>
    </div>
  );
}